import React from "react";
import MintNFT from "./MintNFT";

function App() {
  return (
    <div className="App">
      <MintNFT />
    </div>
  );
}

export default App;
